import { render, staticRenderFns } from "./browserMask.vue?vue&type=template&id=2b8c3553&scoped=true"
import script from "./browserMask.vue?vue&type=script&lang=js"
export * from "./browserMask.vue?vue&type=script&lang=js"
import style0 from "./browserMask.vue?vue&type=style&index=0&id=2b8c3553&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b8c3553",
  null
  
)

export default component.exports